<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { GET_VEHICLE_GROUPS } from '@/services/api/setting/fleet/fleetGroup'
import {
  GET_USER_GROUP_DETAIL,
  GET_MGROUPS,
  GET_MGROUP,
  CREATE_USER_GROUP,
  UPDATE_USER_GROUP,
} from '@/services/api/setting/user/userGroup'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McEmptyState from '@/components/McEmptyState'

export default {
  components: {
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
    McEmptyState,
  },
  apollo: {
    vgroups: {
      query: GET_VEHICLE_GROUPS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.vgroups.vgroups = data.vgroups.vgroups
          this.filteredVgroups = data.vgroups.vgroups
        }
      },
    },

    ugroup: {
      query: GET_USER_GROUP_DETAIL,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        }
      },
      skip() {
        return !this.$route.params.id && this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          data.ugroup.ugroup.vgroups.forEach((row, index) => {
            data.ugroup.ugroup[index] = {
              ...row,
              checked: false,
            }
          })
          this.totalRows = data.ugroup.ugroup.vgroups.length
          this.initEditPage(data.ugroup.ugroup)
          this.uGroupName = data.ugroup.ugroup.name
          localStorage.setItem('ugroup-form-update', JSON.stringify(data.ugroup.ugroup))
        }
      },
    },
  },
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  data() {
    return {
      id: this.$route.params.id,
      selected: {
        fleetGroup: [],
        vGroup: [],
      },
      selectedModel: {
        fleetGroup: [],
        vGroup: [],
      },
      allSelected: {
        fleetGroup: false,
        vGroup: false,
      },
      indeterminate: {
        fleetGroup: true,
        vGroup: true,
      },
      vgroups: {
        vgroups: [],
      },

      ugroup: {
        ugroup: [],
      },
      formOld: {},
      form: {
        name: '',
        mgroups: null,
        vgroups: [],
      },
      filterVgroup: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      filteredVgroups: [],
      fullObject: {
        mgroups: {},
      },
      uGroupName: null,
    }
  },

  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return !this.$route.params.id && this.$route.params.id === undefined
        ? this.$t('setting.list.userSetting.addUserGroup')
        : this.$t('setting.list.userSetting.changeUserGroup')
    },

    items() {
      return [
        {
          text: 'Pengaturan',
          to: '/setting',
        },
        {
          text: this.$t('setting.list.userSetting.pengaturanPengguna'),
          to: '/setting/user',
        },
        {
          text:
            !this.$route.params.id && this.$route.params.id === undefined
              ? this.$t('setting.list.userSetting.addUserGroup')
              : this.form.name,
        },
      ]
    },
    rows() {
      return this.form.vgroups.length
    },

    totalTrueVGroup() {
      return this.selectedModel.vGroup.filter((c) => c === true)
    },

    fleetGroup() {
      return [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'name',
          label: this.$t('setting.list.userSetting.grupKendaraan'),
          sortable: true,
        },
      ]
    },

    fleetGroupModal() {
      return [
        {
          key: 'columnCheckModal',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'name',
          label: this.$t('setting.list.userSetting.grupKendaraan'),
          sortable: true,
        },
      ]
    },

    linkedVGroup() {
      return this.form.vgroups
    },

    vGroupOptions() {
      let linked = this.linkedVGroup.map((item) => item.id)

      let options = this.vgroups.vgroups.filter(function (item) {
        return !linked.includes(item.id)
      })

      return options
    },

    oldData() {
      return this.ugroup.ugroup
    },

    oldDataVgroup() {
      return this.ugroup.ugroup.vgroups
    },

    isIndeterminateFleetGroup() {
      return this.handleIndeterminate('fleetGroup')
    },
    isIndeterminateVGroup() {
      return this.handleIndeterminate('vGroup')
    },
    resourcefulQuery() {
      return {
        mgroups: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }
          const res = await this.$apollo.query({
            query: GET_MGROUPS,
            variables: {
              filter: filter,
            },
          })

          let mgroups = res.data.mgroups.mgroups

          result = {
            metadata: {
              total_count: mgroups.pagination.total,
              page: mgroups.pagination.page,
            },
            data: {
              paginated_result: mgroups.data,
            },
          }

          return result
        },
      }
    },
  },

  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    initEditPage(item) {
      let mGroup = {}
      this.$apollo
        .query({
          query: GET_MGROUP,
          variables: {
            filter: {
              mgroupId: item.mgroupId,
            },
          },
        })
        .then((response) => {
          if (response.data.mgroup.isSuccessful) {
            mGroup = response.data.mgroup.mgroup
            this.fullObject.mgroups = mGroup
            this.form.mgroups = item.mgroupId
            this.formOld.mgroups = this.form.mgroups
          } else {
            return this.$mcToast.error(this.$t('setting.list.fleetGroup.mgroup.alert.notFound'))
          }
        })
      this.form = {
        name: item.name,
        mgroups: mGroup,
        vgroups: item.vgroups,
      }
      this.formOld = {
        name: item.name,
        mgroups: mGroup,
        vgroups: item.vgroups,
      }
      this.filteredItems = item.vgroups
      this.filteredVgroups = this.vGroupOptions
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
      this.filteredItems = filteredItems
    },
    onFilteredModal(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredVgroups = filteredItems
    },
    toggleAll(event, param) {
      const itemsToIterate = param === 'fleetGroup' ? this.filteredItems : this.filteredVgroups
      if (event.target.checked) {
        for (const iterator of itemsToIterate) {
          this.selected[param].push(iterator.id)
        }
        this.selected[param] = [...new Set(this.selected[param])]
      } else {
        for (const iterator of itemsToIterate) {
          let index = this.selected[param].indexOf(iterator.id)
          if (index !== -1) {
            this.selected[param].splice(index, 1)
          }
        }
      }
    },
    toggleAllModal(checked, param) {
      this.selected[param] = checked ? this.vGroupOptions.slice(0) : []
      this.vgroups.vgroups.forEach((val) => (val.checked = checked))
    },
    checkTable(event, data, param) {
      const vgroupId = Number(data.item.id)

      if (event.target.checked) {
        this.selected[param].push(vgroupId)
        this.selected[param] = [...new Set(this.selected[param])]
        this.allSelected[param] = (
          param === 'fleetGroup' ? this.filteredItems : this.filteredVgroups
        ).every((item) => this.selected[param].includes(item.id))
      } else {
        this.allSelected[param] = false
        const index = this.selected[param].indexOf(vgroupId)
        if (index !== -1) {
          this.selected[param].splice(index, 1)
        }
      }
    },
    toSave() {
      if (!this.form.name || this.form.mgroups === undefined || this.form.mgroups === null) {
        this.$refs.formRef.showErrors()

        return this.$mcToast.error(this.$t('global.validation.required'))
      }

      let groupId = this.form.vgroups.map((item) => parseInt(item.id))

      if (this.id === undefined) {
        let inputAdd = {
          name: this.form.name,
          mgroupId: this.form.mgroups,
          vehicleGroups: groupId,
        }

        this.$apollo
          .mutate({
            mutation: CREATE_USER_GROUP,
            variables: {
              input: inputAdd,
            },
          })
          .then((response) => {
            if (response.data.createUgroup.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))
              localStorage.removeItem('ugroup-form-update')

              setTimeout(() => {
                this.$router.push({
                  name: 'List User Setting',
                })
              }, 500)
            } else {
              return this.$mcToast.error(response.data.createUgroup.message)
            }
          })
      } else {
        let oldData = JSON.parse(localStorage.getItem('ugroup-form-update'))
        let oldGroupId = oldData.vgroups.map((item) => parseInt(item.id))
        let inputEdit = {
          id: parseInt(this.id),
          oldData: {
            name: oldData.name,
            vehicleGroups: oldGroupId,
            mgroupId: oldData.mgroupId,
          },
          newData: {
            name: this.form.name,
            vehicleGroups: groupId,
            mgroupId: this.form.mgroups,
          },
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_GROUP,
            variables: {
              input: inputEdit,
            },
          })
          .then((response) => {
            if (response.data.updateUgroup.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))
              localStorage.removeItem('ugroup-form-update')

              setTimeout(() => {
                this.$router.push({
                  name: 'List User Setting',
                })
              }, 500)
            } else {
              return this.$mcToast.error(response.data.updateUgroup.message)
            }
          })
      }
    },

    toSaveSU() {
      if (this.linkedVGroup.length == 0) {
        if (!this.form.name || this.form.mgroups === undefined || this.form.mgroups === null) {
          this.$refs.formRef.showErrors()

          return this.$mcToast.error(this.$t('global.validation.required'))
        }
        this.$refs['modal-nogroup'].show()
      } else {
        this.toSave()
      }
    },

    toDelete() {
      this.selected.fleetGroup.forEach((row) => {
        this.form.vgroups = this.form.vgroups.filter(function (item) {
          return item.id !== row
        })
      })
      const mgroup = this.form.mgroups
      this.selected.fleetGroup = []

      this.allSelected.fleetGroup = false

      this.totalRows = this.linkedVGroup.length
      this.clearList()

      this.filteredItems = this.form.vgroups
      this.filteredVgroups = this.vGroupOptions
      this.$bvModal.hide('modal-delete-group')
      // this is a temporary fix but we will need to enhance this component, especially the table
      // but we will need an enhancement from BE as well for pagination
      setTimeout(() => {
        this.form.mgroups = mgroup
      }, 400)
    },
    clearGroup() {
      this.allSelected.vGroup = false
      this.selectedModel.vGroup = []
      this.selected.vGroup = []
    },
    clearList() {
      this.allSelected.fleetGroup = false
      this.selectedModel.fleetGroup = []
      this.selected.fleetGroup = []
    },
    selectVGroup() {
      const selectedItems = this.vGroupOptions.filter((item) =>
        this.selected.vGroup.includes(item.id)
      )
      this.form.vgroups.push(...selectedItems)
      this.totalRows = this.linkedVGroup.length
      this.filteredItems = this.form.vgroups
      this.filteredVgroups = this.vGroupOptions
      this.selected.vGroup = []
      this.$bvModal.hide('modal-filter')
    },
    handleIndeterminate(param) {
      let maxValue
      if (param == 'fleetGroup') {
        maxValue = this.linkedVGroup.length
      } else {
        maxValue = this.vGroupOptions.length
      }
      if (this.selected[param].length == 0) {
        this.allSelected[param] = false
        return false
      } else if (
        maxValue == this.selected[param].length ||
        this.filteredItems.length == this.selected[param].length
      ) {
        this.allSelected[param] = true
        return false
      } else {
        this.allSelected[param] = false
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/setting/user" />

          <McButton
            class="ms-2"
            variant="primary"
            icon="icon-outline_save"
            :text="$t('global.save')"
            :disabled="form.mgroups === 0 || uGroupName === 'Super User Operational'"
            @click="toSaveSU()"
          />
        </div>
      </div>
    </div>

    <FormulateForm ref="formRef" v-model="form">
      <b-row class="mt-3 mb-4">
        <b-col md="4">
          <FormulateInput
            name="name"
            help="required"
            :label="$t('master.user.group')"
            :placeholder="$t('master.user.group')"
            validation="required:trim"
            :validation-messages="{
              required: $t('global.validation.required'),
            }"
            error-behavior="blur"
            validation-behavior="blur"
            :disabled="
              form.mgroups === 0 || (hasUserGroupFlag && uGroupName === 'Super User Operational')
            "
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            v-model="form.mgroups"
            name="mgroup"
            :placeholder="$t('global.field.choosePermission')"
            :label="$t('setting.list.userSetting.hakAkses')"
            type="select-resourceful-v2"
            :trackBy="'mgroupId'"
            validation="required"
            help="required"
            :validation-messages="{
              required: $t('global.validation.required'),
            }"
            error-behavior="blur"
            validation-behavior="blur"
            :optionsGetter="resourcefulQuery.mgroups"
            :optionLabelFn="({ item }) => item.name"
            :multiple="false"
            :disabled="
              form.mgroups === 0 || (hasUserGroupFlag && uGroupName === 'Super User Operational')
            "
            :fullObject="fullObject.mgroups"
            @update:fullObject="($event) => (fullObject.mgroups = $event)"
          />
        </b-col>
      </b-row>
    </FormulateForm>

    <div
      v-if="
        form.mgroups === null ||
        (fullObject.mgroups.mgroupId !== 0 &&
          (!hasUserGroupFlag || uGroupName !== 'Super User Operational'))
      "
    >
      <div class="clearfix mb-3 pb-3 border-3 border-bottom mc-list-header">
        <div class="float-end">
          <McButton
            v-if="selected.fleetGroup.length"
            v-b-modal.modal-delete-group
            variant="secondary-red"
            icon="icon-outline_trash"
            :text="$t('global.delete')"
            class="mx-2"
          />
          <McButton
            v-b-modal.modal-filter
            icon="icon-outline_plus"
            :text="$t('global.addField')"
            href="javascript: void(0);"
          />
        </div>
      </div>

      <b-card>
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="selected.fleetGroup.length" class="mc-row-check">
              <span class="badge btn-success">{{ selected.fleetGroup.length }}</span>
              {{ $t('global.selectedRows') }}.
              <a class="color-primary" @click="clearList">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <label
              class="d-inline-flex align-items-center mc-table-view__search"
              @click="focusSearch"
            >
              <i class="mc-fa fas fa-search" />
              <b-form-input
                ref="searchInput"
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="form-control ms-2"
                @input="allSelected.fleetGroup = false"
              />
            </label>
          </div>
        </div>

        <div class="table-responsive my-3 border border-1">
          <b-table
            ref="fleetGroupTable"
            small
            show-empty
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :empty-text="$t('global.emptyTable')"
            :fields="fleetGroup"
            :items="linkedVGroup"
            class="datatables"
            responsive="sm"
            empty-table
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(columnCheck)>
              <div class="form-check">
                <input
                  v-model="allSelected.fleetGroup"
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  @input="toggleAll($event, 'fleetGroup')"
                />
              </div>
            </template>

            <template #cell(columnCheck)="data">
              <div class="form-check">
                <input
                  v-model="selected.fleetGroup"
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.id"
                  @change="checkTable($event, data, 'fleetGroup')"
                />
              </div>
            </template>

            <template #cell(name)="data">
              <span>
                {{ data.item.name }}
              </span>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  v-model="perPage"
                  class="form-select form-select-sm"
                  size="sm"
                  :options="pageOptions"
                />
                {{ $t('global.entry') }}.
                <p>
                  {{ $t('global.show') }}
                  <strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong>
                  -
                  <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong>
                  {{ $t('global.object.of') }}
                  <strong>{{ filteredItems.length }}.</strong>
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
              </ul>
            </div>
          </div>
        </div>

        <b-alert :show="linkedVGroup.length == 0" variant="primary" class="mc-alert mt-4">
          <i class="mc-fa icon-fill_info" />
          {{ $t('setting.list.userSetting.userGroupAlert') }}
        </b-alert>
      </b-card>
    </div>
    <div v-else>
      <McEmptyState
        :title="$t('setting.list.userSetting.emptyStateTitle')"
        :desc="$t('setting.list.userSetting.emptyStateDesc')"
        class="mc-data__blank--list-noimg"
        :hasButton="false"
      />
    </div>

    <b-modal
      id="modal-filter"
      class="mc-modal"
      :title="$t('setting.list.userSetting.addFleet')"
      size="lg"
      centered
      scrollable
      @hidden="clearGroup"
    >
      <div class="row">
        <div class="col-sm-12 col-md-5 mc-row-check-wrapper">
          <h6 v-if="selected.vGroup.length" class="mc-row-check">
            <span class="badge btn-success">{{ selected.vGroup.length }}</span>
            {{ $t('global.selectedRows') }}
            <a class="color-primary" @click="clearGroup">{{ $t('global.action.clearAll') }}</a>
          </h6>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-7 d-flex flex-row-reverse mc-table-view-wrapper">
          <label
            class="d-inline-flex align-items-center mc-table-view__search"
            @click="focusSearch"
          >
            <i class="mc-fa fas fa-search" />
            <b-form-input
              ref="searchInput"
              v-model="filterVgroup"
              type="search"
              :placeholder="$t('global.search') + '...'"
              class="form-control ms-2"
              @input="allSelected.vGroup = false"
            />
          </label>
        </div>
        <!-- End search -->
      </div>

      <!-- Table Tambah Kendaraan -->
      <div class="table-responsive mt-3 border border-1">
        <b-table
          small
          show-empty
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :fields="fleetGroupModal"
          :items="vGroupOptions"
          class="datatables"
          responsive="sm"
          empty-table
          :empty-text="
            vgroups.vgroups.length == 0 ? $t('global.emptyTable') : 'Tidak ada grup untuk dipilih'
          "
          :current-page="currentPage"
          :filter="filterVgroup"
          :filter-included-fields="filterOn"
          @filtered="onFilteredModal"
        >
          <template #head(columnCheckModal)>
            <div class="form-check">
              <input
                v-model="allSelected.vGroup"
                class="form-check-input me-1"
                type="checkbox"
                value="all"
                @input="toggleAll($event, 'vGroup')"
              />
            </div>
          </template>

          <template #cell(columnCheckModal)="data">
            <div class="form-check">
              <input
                v-model="selected.vGroup"
                class="form-check-input me-1"
                type="checkbox"
                :value="data.item.id"
                @change="checkTable($event, data, 'vGroup')"
              />
            </div>
          </template>
        </b-table>
      </div>

      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" class="text-end">
            <McButton
              variant="secondary"
              :text="$t('global.action.cancel')"
              class="me-3"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.action.apply')" @click="selectVGroup()" />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      id="modal-delete-group"
      class="mc-modal"
      :title="$t('global.delete')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.confirmDelete1') }} <strong>{{ selected.fleetGroup.length }}</strong>
          {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              :text="$t('global.action.no')"
              class="me-2"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.yes')" @click="toDelete" />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      id="modal-nogroup"
      ref="modal-nogroup"
      :title="$t('setting.list.userSetting.noGroupModal')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('setting.list.userSetting.noGroupDesc') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              :text="$t('global.action.cancel')"
              class="me-2"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.next')" @click="toSave" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
